import type {} from "@mui/lab/themeAugmentation";
import "@mui/lab/themeAugmentation";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import Modal from "../../components/Modal";
import { ClickableIcon } from "../../components/Icon";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ConfirmButton } from "../../components/Button";
type Props = {
  isOpen: boolean;
  setOpen?: any;
  setAdoptInfo?: any;
  title: string;
  info: string;
};
const CustomFlex = styled(FlexBox)`
  margin-bottom: 20px;
  align-items: flex-start;
`;
const Header = styled.h4`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const Flex = styled(FlexGrow)`
  padding: 24px;
  //   width: 318px;
  background: rgba(236, 197, 198, 0.1);
  border-radius: 4px;
`;

export default function AdoptDetail({
  isOpen,
  title,
  info,
  setAdoptInfo,
}: Props) {
  const infoItems =
    info
      ?.split(/[;.]/)
      .map((item) => item.trim())
      .filter((item) => item !== "") || "";

  return (
    <Modal
      isOpen={isOpen || false}
      setOpen={() => {
        setAdoptInfo(null);
      }}
      customStyle={{
        content: {
          maxWidth: "1000px",
          padding: 20,
          background: "#090d20",
          border: "1px solid #2D416C",
          boxShadow: "0px 4px 16px rgba(0,0,0)",
          borderRadius: "8px",
          marginTop: 100,
        },
      }}
    >
      <CustomFlex>
        <FlexGrow>
          <Header>{title}</Header>
        </FlexGrow>
        <ClickableIcon name="times" onClick={() => setAdoptInfo(null)} />
      </CustomFlex>
      <Flex>
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          {infoItems.map((item, index) => (
            <li key={index} style={{ marginBottom: "8px" }}>
              {item}
            </li>
          ))}
        </ul>
      </Flex>

      <FlexBox justify="end" style={{ paddingTop: 20 }}>
        <ConfirmButton disabled={true} onClick={() => setAdoptInfo(null)}>
          Close
        </ConfirmButton>
      </FlexBox>
    </Modal>
  );
}
